import getRpgLogsApiAccessToken from './getRpgLogsApiAccessToken';
import config, { getBaseUrl } from '../config';
import { getRequestMetadataHeaders } from './rpgLogsApiRequestMetadata';

async function fetchJsonFromRpgLogsApi(
  query,
  variables = {},
  gameSlug,
  retryOnFailure = true,
  attemptNumber = 1,
  userAccessToken
) {
  const body = JSON.stringify({ query, variables });
  const requestMetadataHeaders = getRequestMetadataHeaders();

  try {
    const accessToken =
      userAccessToken ?? (await getRpgLogsApiAccessToken(gameSlug));
    const url = `${getBaseUrl(gameSlug)}/api/v2/${
      userAccessToken ? 'archon-user' : 'archon'
    }${config.isDevelopment ? '?XDEBUG_SESSION_START=PHPSTORM' : ''}`;

    if (config.isDevelopment) {
      console.log({
        url,
        body,
      });
    }

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
        ...requestMetadataHeaders,
      },
      body,
    });

    let json = null;
    const text = await response.text();
    try {
      json = JSON.parse(text);
    } catch (error) {
      if (config.isDevelopment) {
        console.log({
          url,
          body: { query, variables },
          error,
          text,
        });
      }

      throw 'RPGLogs GraphQL response did not contain JSON.';
    }

    if (json.errors) {
      throw {
        message: 'RPGLogs GraphQL response contained errors.',
        errors: JSON.stringify(json.errors, null, 2),
        query,
        variables,
      };
    }

    const data = json.data;

    if (!data) {
      throw {
        message: 'RPGLogs GraphQL response did not return data or errors.',
        json: JSON.stringify(json, null, 2),
        query,
        variables,
      };
    }

    return data;
  } catch (error) {
    if (config.isCI && retryOnFailure && attemptNumber < 3) {
      const delay = 5000 * attemptNumber;

      console.warn(
        error,
        body,
        requestMetadataHeaders['x-archon-route'],
        requestMetadataHeaders['x-archon-path']
      );
      console.log(
        `RPGLogs GraphQL request failed, retrying in ${delay}ms (${attemptNumber}/3)...`
      );

      await new Promise((resolve) => setTimeout(resolve, delay));

      return await fetchJsonFromRpgLogsApi(
        query,
        variables,
        gameSlug,
        retryOnFailure,
        attemptNumber + 1
      );
    }

    throw error;
  }
}

export default fetchJsonFromRpgLogsApi;
